import {
  PersonIcon_default
} from "./chunk-ZWDN2MK3.mjs";
export {
  PersonIcon_default as default
};
